import { render } from "./attachment_view.vue?vue&type=template&id=528c9db1&scoped=true"
import script from "./attachment_view.vue?vue&type=script&lang=js"
export * from "./attachment_view.vue?vue&type=script&lang=js"

import "./attachment_view.vue?vue&type=style&index=0&id=528c9db1&lang=scss&scoped=true"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528c9db1"]])

export default __exports__